module.exports = __webpack_public_path__ + "media/styles/images/svg/arrow-right-gray-73269d6385797e52b892b8b9448a8a65.svg";